export default __webpack_public_path__ + "static/tovarBaba-34db9ff48628953cac51b684ef80b259.png";